import React, { useState, useEffect } from "react";
import { formatINR } from "utils";

const ProductDetails = ({
  product,
  pincode,
  setPincode,
  checkAvailability,
}: any) => {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [localMessage, setLocalMessage] = useState("");

  const handleInputChange = (value: string) => {
    // Allow only digits and max 6 chars
    const numericValue = value.replace(/\D/g, "").slice(0, 6);
    setPincode(numericValue);

    // Reset previous status/message while typing
    setStatus("idle");
    setLocalMessage("");
  };

  const handleCheck = async () => {
    // Trim spaces just in case
    const trimmedPincode = pincode.trim();

    // Validate 6-digit numeric pincode
    if (!/^\d{6}$/.test(trimmedPincode)) {
      setStatus("error");
      setLocalMessage("Please enter a valid 6-digit pincode");
      return;
    }

    try {
      const result = await checkAvailability();
      if (result?.serviceable?.serviceable) {
        setStatus("success");
        setLocalMessage(result.serviceable.Message || "Delivery available at this pincode!");
      } else {
        setStatus("error");
        setLocalMessage(result.serviceable?.Message || "Currently we are not delivering at this pincode.");
      }
    } catch (error) {
      setStatus("error");
      setLocalMessage("Something went wrong. Please try again later.");
    }
  };


  return (
    <div className="step2-right">
      <h2>{product?.productName}</h2>
      <p>
        <strong>Price: </strong>
        {Number(product?.discountedAmount) > 0 ? (
          <>
            <s className="original-price">{formatINR(product?.price)}</s>{" "}
            <b className="discounted-price">{formatINR(product?.discountedPrice)}</b>
          </>
        ) : (
          <b className="discounted-price">{formatINR(product?.price)}</b>
        )}
      </p>

      <p>
        <strong>Purity:</strong> {`${product?.purity}%`}
      </p>
      <p>
        <strong>Quantity:</strong> 1 Unit
      </p>

      <h4>Product Description:</h4>
      <p>{product?.productDescription}</p>

      <h4>Check Delivery Availability:</h4>
      <div className="pincode-check">
        <input
          type="text"
          placeholder="Enter Pincode"
          value={pincode}
          maxLength={6}
          onChange={(e) => handleInputChange(e.target.value)}
        />

        {status === "idle" &&
          <button onClick={handleCheck} disabled={pincode.length === 0}>
            Check
          </button>


        }


        {status === "success" && (
          <button className="success-btn" title="Deliverable">
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 13L9.5 17.5L19 7"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}

        {status === "error" && (
          <button className="error-btn" title="Not deliverable">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        )}
      </div>

      {localMessage && (
        <p
          className="message"
          style={{
            color: status === "success" ? "#2E7D32" : "#D32F2F",
          }}
        >
          {localMessage}
        </p>
      )}
    </div>
  );
};

export default ProductDetails;
